import { OnboardingState } from './types';

export const SELECT_PLAYER_FLOW_DEFAULT_PLAYER = 'WEB';

export const DEFAULT_ONBOARDING_STATE: OnboardingState = {
  inFlow: false,
  flowType: undefined,
  isTemplateMode: false,
};
